import { StateUtils } from '@spartacus/core';
import { ORDER_INVOICE_PAYMENT_ENTITY } from '../order-state';

export const DOWNLOAD_ORDER_INVOICE_PAYMENT = '[MyAccount] Download Order Invoice Payment';
export const DOWNLOAD_ORDER_INVOICE_PAYMENT_SUCCESS = '[MyAccount] Download Order Invoice Payment Success';
export const DOWNLOAD_ORDER_INVOICE_PAYMENT_ERROR = '[MyAccount] Download Order Invoice Payment Error';

export class DownloadOrderInvoicePayment extends StateUtils.EntityLoadAction {
  readonly type = DOWNLOAD_ORDER_INVOICE_PAYMENT;

  constructor(public payload: { orderId: string; orderCode: string }) {
    super(ORDER_INVOICE_PAYMENT_ENTITY, payload.orderId);
  }
}

export class DownloadOrderInvoicePaymentSuccess extends StateUtils.EntitySuccessAction {
  readonly type = DOWNLOAD_ORDER_INVOICE_PAYMENT_SUCCESS;

  constructor(payload: { orderId: string }) {
    super(ORDER_INVOICE_PAYMENT_ENTITY, payload.orderId);
  }
}

export class DownloadOrderInvoicePaymentError extends StateUtils.EntityFailAction {
  readonly type = DOWNLOAD_ORDER_INVOICE_PAYMENT_ERROR;

  constructor(payload: { orderId: string; error: unknown }) {
    super(ORDER_INVOICE_PAYMENT_ENTITY, payload.orderId, payload.error);
  }
}

export type OrderInvoicePaymentActions =
  | DownloadOrderInvoicePayment
  | DownloadOrderInvoicePaymentSuccess
  | DownloadOrderInvoicePaymentError;
